
import { LeftOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'pageTit',
  components: {
    LeftOutlined,
  },
  props: {
    pagetitName: String,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const isHideTitle = computed(() => {
      const { isQYWeixin, isWeixin, isDingTalk } = store.getters;
      return isQYWeixin || isWeixin || isDingTalk;
    });
    const gobacks = () => {
      if (window.history?.state?.back) {
        router.go(-1);
      } else {
        router.push({ path: '/' });
      }
    };

    return {
      gobacks,
      isHideTitle,
    };
  },
};
